import React from 'react';
import { useMutation } from "@apollo/react-hooks";
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { useFormik } from 'formik';

import validate from '../utils/formik-utils';
import Spinner from 'react-spinkit';

const SIGNUP = gql`
  mutation SIGNUP($name: String!, $email: String!, $password: String!) {
    signup(data: {
      name: $name,
      email: $email,
      password: $password
    }) {
      name
      email
      password
    }
  }
`;

const Signup = (props) => {

  const [signup, { loading }] = useMutation(SIGNUP);

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      password: ''
    },
    validate,
    onSubmit: async (values, { setErrors }) => {
      try {
        const response = await signup({
          variables: values
        });
      } catch (err) {
        const emailError = err.graphQLErrors[0].message;
        setErrors({ email: emailError });
      }
    },
  });


  return (
    <form onSubmit={formik.handleSubmit} class="form">
      <div class="form__group">
        <input
          id="name"
          name="name"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.name}
          className={"form__input " + (formik.errors.name ? 'error' : '')}
          placeholder="name"
        />
        {formik.errors.name ? <span class="danger">{formik.errors.name}</span> : null}
      </div>
      <div class="form__group">
        <input
          id="email"
          name="email"
          type="email"
          onChange={formik.handleChange}
          value={formik.values.email}
          className={"form__input " + (formik.errors.email ? 'error' : '')}
          placeholder="email"
        />
        {formik.errors.email ? <span class="danger">{formik.errors.email}</span> : null}
      </div>
      <div class="form__group">
        <input
          id="password"
          name="password"
          type="password"
          onChange={formik.handleChange}
          value={formik.values.password}
          className={"form__input " + (formik.errors.password ? 'error' : '')}
          placeholder="password"
        />
        {formik.errors.password ? <span class="danger">{formik.errors.password}</span> : null}
      </div>
      <button class="btn form__btn" type="submit">Register {loading ? <span className="ml-3"><Spinner name="circle" /></span> : null}</button>
    </form>
  );
}

export default withRouter(Signup);